module.exports = __webpack_public_path__ + "img/turn1north.bc9d2791.jpg";